import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./routes";
import { HeartbeatProvider } from "./contexts/HeartbeatContext";
import "./index.css";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HeartbeatProvider>
        <RouterProvider router={router} />
      </HeartbeatProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
